module.exports = __webpack_public_path__ + "static/img/timer_img.53903ebe.png";